import React, { useState, useEffect } from 'react'
import { Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import './assets/scss/styles.scss'
import { getCurrentLanguage, translate } from '../../assets/js/functions'
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs';
import { domain, getReport } from '../../assets/js/api';
import { FaFilePdf } from 'react-icons/fa';

export default function Report() {

    const title = translate("Informe");
    const [document, setDocument] = useState(null)

   useEffect(() => {
       getReport(getCurrentLanguage()).then(
           (res) => {
               setDocument(domain + JSON.parse(res.data.result[0].pdf_resolved)[0])
            //    window.open(domain + JSON.parse(res.data.result[0].pdf_resolved)[0])
           }
       )
   }, [])

    return (
        <div id="report">
            <Breadcrumbs currentSite={title}/>
            <>
                <h2>{title}</h2>
                <Container className='text-center'>
                   { document ? <a href={document} className='btn btn-danger mt-5' target={"_blank"}><FaFilePdf/> { translate("Ver Informe") }</a> : null }
                </Container>
                <Helmet>
                    <title>{title}</title>
                </Helmet>
            </>
        </div>
    )
}
